/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsEnergyConsumptionRate } from "../../funcs/metricsGetApiV3MetricsEnergyConsumptionRate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MetricsEnergyConsumptionRateRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsEnergyConsumptionRate: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-energy-consumption-rate",
  description:
    `Deprecated: Use \`/api/v3/metrics/node-energy-consumption-rate-kwh\`
and \`/api/v3/metrics/total-ic-energy-consumption-rate-kwh\` instead`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await metricsGetApiV3MetricsEnergyConsumptionRate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
